export function Body({ children }) {
  return <div className="h-full flex flex-col">{children}</div>;
}
